import { useState, useEffect } from "react";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
} from "context";
// import { modules } from "utility/data";
import { useSelector } from "react-redux";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth.auth?.user);
  const modules = auth?.modules || [];


  // Track which collapsible menus are open
  const [openMenus, setOpenMenus] = useState({});

  // Extract first segment of path to match keys like "beauty-app"
  const collapseName = location.pathname.split("/")[1];
  const currentPath = location.pathname;
  let textColor = "white";
  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  // Auto open submenu if current route is inside submenu
  useEffect(() => {
    routes.forEach(({ key, collapse }) => {
      if (collapse) {
        collapse.forEach(({ route }) => {
          if (route && location.pathname.startsWith(route)) {
            setOpenMenus((prev) => ({ ...prev, [key]: true }));
          }
        });
      }
    });
  }, [location.pathname, routes]);

  useEffect(() => {
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
    }
    window.addEventListener("resize", handleMiniSidenav);
    handleMiniSidenav();
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location, transparentSidenav, whiteSidenav]);

  const Logout = () => {
    localStorage.removeItem("tokenf");
    navigate("/authentication/sign-in");
    window.location.reload("/");
  };

  // Toggle open/close state for a collapsible menu item by key
  const handleToggle = (key) => {
    setOpenMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Recursive rendering of routes
  // const renderRoutes = (routesList) =>
  //   routesList.map(({ type, name, icon, title, noCollapse, key, href, route, collapse }) => {
  //     if (type === "collapse") {
  //       if (collapse && collapse.length > 0) {
  //         // Parent menu with nested collapsible items
  //         return (
  //           <div key={key}>
  //             <SidenavCollapse
  //               name={name}
  //               icon={icon}
  //               active={key === collapseName}
  //               noCollapse={noCollapse}
  //               onClick={() => handleToggle(key)}
  //               sx={{ cursor: "pointer", userSelect: "none" }}
  //               endIcon={
  //                 openMenus[key] ? (
  //                   <Icon sx={{ fontSize: "16px" }}>expand_less</Icon>
  //                 ) : (
  //                   <Icon sx={{ fontSize: "16px" }}>expand_more</Icon>
  //                 )
  //               }
  //             />
  //             {openMenus[key] && (
  //               <List component="div" disablePadding sx={{ pl: 3 }}>
  //                 {renderRoutes(collapse)}
  //               </List>
  //             )}
  //           </div>
  //         );
  //       }

  //       if (href) {
  //         return (
  //           <Link
  //             href={href}
  //             key={key}
  //             target="_blank"
  //             rel="noreferrer"
  //             sx={{ textDecoration: "none" }}
  //           >
  //             <SidenavCollapse
  //               name={name}
  //               icon={icon}
  //               active={key === collapseName}
  //               noCollapse={noCollapse}
  //             />
  //           </Link>
  //         );
  //       }

  //       return (
  //         <NavLink
  //           key={key}
  //           to={route}
  //           style={{ textDecoration: "none" }}
  //           end
  //         >
  //           <SidenavCollapse
  //             name={name}
  //             icon={icon}
  //             active={key === collapseName}
  //             noCollapse={noCollapse}
  //           />
  //         </NavLink>
  //       );
  //     }

  //     if (type === "title") {
  //       return (
  //         <MDTypography
  //           key={key}
  //           color={textColor}
  //           display="block"
  //           variant="caption"
  //           fontWeight="bold"
  //           textTransform="uppercase"
  //           pl={3}
  //           mt={2}
  //           mb={1}
  //           ml={1}
  //         >
  //           {title}
  //         </MDTypography>
  //       );
  //     }

  //     if (type === "divider") {
  //       return (
  //         <Divider
  //           key={key}
  //           light={
  //             (!darkMode && !whiteSidenav && !transparentSidenav) ||
  //             (darkMode && !transparentSidenav && whiteSidenav)
  //           }
  //         />
  //       );
  //     }

  //     return null;
  //   });

  const hasAccess = (routeName, modules) => {
    for (let mod of modules) {
      if (mod.name === routeName && mod.access) return true;

      for (let sub of mod.subModules || []) {
        if (sub.name === routeName && sub.access) return true;
      }
    }
    return false;
  };

  const renderRoutes = (routesList) =>
    routesList.map(({ type, name, icon, title, noCollapse, key, href, route, collapse }) => {

      if (auth?.role === "staff") {
        if (!hasAccess(name, modules)) return null;
      }
      if (type === "collapse") {
        if (collapse && collapse.length > 0) {
          const filteredCollapse =
            auth?.role === "staff"
              ? collapse.filter((r) => hasAccess(r.name, modules))
              : collapse; // if not staff, show all

          if (filteredCollapse.length === 0) return null;

          const isParentActive = collapse.some((r) => r.route && currentPath === r.route);

          return (
            <div key={key}>
              <SidenavCollapse
                name={name}
                icon={icon}
                active={isParentActive}
                noCollapse={noCollapse}
                onClick={() => handleToggle(key)}
                sx={{ cursor: "pointer", userSelect: "none" }}
                endIcon={
                  openMenus[key] ? (
                    <Icon sx={{ fontSize: "16px" }}>expand_less</Icon>
                  ) : (
                    <Icon sx={{ fontSize: "16px" }}>expand_more</Icon>
                  )
                }
              />
              {openMenus[key] && (
                <List component="div" disablePadding sx={{ pl: 3 }}>
                  {renderRoutes(filteredCollapse)}
                </List>
              )}
            </div>
          );
        }

        if (href) {
          return (
            <Link
              href={href}
              key={key}
              target="_blank"
              rel="noreferrer"
              sx={{ textDecoration: "none" }}
            >
              <SidenavCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}
              />
            </Link>
          );
        }

        return (
          <NavLink
            key={key}
            to={route}
            style={{ textDecoration: "none" }}
            end
          >
            <SidenavCollapse
              name={name}
              icon={icon}
              active={currentPath === route}
              noCollapse={noCollapse}
            />
          </NavLink>
        );
      }

      if (type === "title") {
        return (
          <MDTypography
            key={key}
            color={textColor}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </MDTypography>
        );
      }

      if (type === "divider") {
        return (
          <Divider
            key={key}
            light={
              (!darkMode && !whiteSidenav && !transparentSidenav) ||
              (darkMode && !transparentSidenav && whiteSidenav)
            }
          />
        );
      }

      return null;
    });


  return (
    <SidenavRoot
      {...rest}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
    >
      <MDBox pt={3} pb={1} px={4} textAlign="center">
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MDTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </MDTypography>
        </MDBox>
        <MDBox component={NavLink} to="/" display="flex" alignItems="center">
          {brand && <MDBox component="img" src={brand} alt="Brand" width="100%" />}
          {/* Uncomment below to show brandName text */}
          {/* <MDBox sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}>
            <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
              {brandName}
            </MDTypography>
          </MDBox> */}
        </MDBox>
      </MDBox>

      <Divider
        light={
          (!darkMode && !whiteSidenav && !transparentSidenav) ||
          (darkMode && !transparentSidenav && whiteSidenav)
        }
      />

      <List>{renderRoutes(routes)}</List>

      <MDBox p={2} mt="auto">
        <MDButton onClick={Logout} variant="gradient" color={sidenavColor} fullWidth>
          Logout
        </MDButton>
      </MDBox>
    </SidenavRoot>
  );
}

Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

Sidenav.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
